import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class EventDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'action',
      type: 'Schema.Union',
      types: [
        {
          type: 'Schema.Action'
        },
        {
          items: {
            type: 'Schema.Action'
          },
          type: 'Schema.Array'
        }
      ]
    },
    {
      name: 'condition',
      type: 'Schema.Union',
      types: [
        {
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Boolean'
        }
      ]
    },
    {
      name: 'debounceTime',
      type: 'Schema.Union',
      types: [
        {
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    },
    {
      name: 'throttleTime',
      type: 'Schema.Union',
      types: [
        {
          type: 'Schema.Mustache'
        },
        {
          type: 'Schema.Number'
        }
      ]
    }
  ]

  override relationTo = 'Schema.Event'
}
